import React from "react";
import { v4 } from "uuid";

import "../ListView.scss";
import FilePrimary from "../../../assets/icons/file_pdf.svg";
import SharedWith from "../../SharedWith/SharedWith";
import Dropdown from "../../UI/DropDown/DropDown";
import CheckBox from "../../UI/CheckBox/CheckBox";
import Pin from "../../UI/Pin/Pin";
import ItemNameIcon from "./ItemNameIcon/ItemNameIcon";
import ProfileWithName from "./ProfileWithName/ProfileWIthName";
import RightArrow from "../../../assets/icons/arrows/chevron-right.svg";

import folderColor1 from "../../../assets/icons/small_folder_icon/folder_color-1.svg";
import folderColor2 from "../../../assets/icons/small_folder_icon/folder_color-2.svg";
import folderColor3 from "../../../assets/icons/small_folder_icon/folder_color-3.svg";
import folderColor4 from "../../../assets/icons/small_folder_icon/folder_color-4.svg";
import folderColor5 from "../../../assets/icons/small_folder_icon/folder_color-5.svg";
import folderColor6 from "../../../assets/icons/small_folder_icon/folder_color-6.svg";
import folderColorPrimary from "../../../assets/icons/small_folder_icon/folder_primary.svg";
import { getName, getIntials, getParsedDate } from "../../../helper";
import { NavLink } from "react-router-dom";

const colors = {
  "#ff9ead": folderColor1,
  "#ffa575": folderColor2,
  "#ffda6b": folderColor3,
  "#86e575": folderColor4,
  "#6de4d2": folderColor5,
  "#c09eff": folderColor6,
  "#cbd1fe": folderColorPrimary,
};
const statusMappings = {
  active: "btn-active",
  draft: "btn-draft",
  received: "btn-received",
};

const DynamicListViewRows = (props) => {
  const {
    onOpenApprovalStatusHandler = () =>
      console.log("onOpenApprovalStatusHandler is not provided"),
    shouldShowApprovalLevel = false,
    item: { approvalLevels = [] } = {},
  } = props;
  const JSXMapping = {
    files: (
      <td
        key={v4()}
        className={
          props.size
            ? `d-flex ${props.checked ? "folderlist-checked" : ""}`
            : `${props.checked ? "folderlist-checked" : ""}`
        }
      >
        {props.isColumns.isCheckbox ? (
          <CheckBox
            folderId={props.item.id}
            checkHandler={() => props.checkHandler(props.item.id)}
            checked={props.checked}
          />
        ) : null}
        <ItemNameIcon
          itemIcon={
            props.isFolder
              ? colors[props.item.color.name || "#cbd1fe"]
              : FilePrimary
          }
          item={props.item}
          isFolder={props.isFolder}
          onClick={props.onClick} // only for documents
          isArchivedView={props.isArchivedView}
          {...props}
        />
        {props.isColumns.isPinned ? (
          <Pin
            checkPin={props.checkPin}
            pinHandler={() => props.pinHandler(props.item.id)}
            folderId={props.id}
            pinnedClass={props.pinnedClass}
          />
        ) : null}
      </td>
    ),
    status: props.isColumns.isStatus ? (
      <StatusButton
        item={props?.item}
        onClick={props.setStatus}
        statusMappings={statusMappings}
      />
    ) : null,
    // activity: (
    //   <td className="d-flex">
    //     <div className="pr-2">{props.item.activity}</div>
    //     <ProfileWithName
    //       sKey={props.item.id}
    //       nameIntial={getIntials(props.item.modifiedBy)}
    //       personName={getName(props.item.modifiedBy)}
    //       profile={props.item.modifiedBy.profile.image}
    //       isPopover={props.isColumns.isPopover}
    //       role={
    //         props.item.modifiedBy.profile
    //           ? props.item.modifiedBy.profile.role.name
    //           : ""
    //       }
    //     />
    //   </td>
    // ),
    addedBy: (
      <td key={v4()}>
        <ProfileWithName
          sKey={props.item.id}
          nameIntial={getIntials(props.item.createdBy)}
          personName={getName(props.item.createdBy)}
          profile={props.item.createdBy.profile.image}
          isPopover={props.isColumns.isPopover}
          role={
            props.item.createdBy.profile
              ? props.item.createdBy.profile.role.name
              : ""
          }
        />
      </td>
    ),
    sharedWith: (
      <td key={v4()}>
        <SharedWith
          itemId={props.item.id}
          item={props.item}
          isPopover={props.isColumns.isPopover}
          isFolder={props.isFolder}
          sharedWithList={props.sharedWithList}
          match={props.match}
          updatedSharedWith={props.updatedSharedWith}
        />
      </td>
    ),
    tagName: (
      <td key={v4()}>
        <div className="tag-name-link">
          {props.item.tag ? (
            <NavLink to={`/files/search/${props.item.tag.name}`}>
              {" "}
              {props.item.tag.name}
            </NavLink>
          ) : (
            ""
          )}
        </div>
      </td>
    ),

    lastModified: <td key={v4()}>{getParsedDate(props.item.lastModified)}</td>,
    location: (
      <td key={v4()}>
        <div className="d-flex text-col-3">
          <div>Archives</div>
          {props.isFolder ? (
            <div className="archive-title">
              {props.item.rootTitle && (
                <img src={RightArrow} alt="Left-arrow" width="16" height="16" />
              )}
              {props.item.rootTitle}
            </div>
          ) : (
            <div className="d-flex">
              <div>
                <img src={RightArrow} alt="Left-arrow" width="16" height="16" />
              </div>
              <div className="archive-title">{props.item.rootTitle}</div>
              <div>
                <img src={RightArrow} alt="Left-arrow" width="16" height="16" />
              </div>
              <div className="archive-title">{props.item.parentTitle}</div>
            </div>
          )}
        </div>
      </td>
    ),
    archivedBy: props.isArchivedView && (
      <td key={v4()}>
        <ProfileWithName
          sKey={props.item.id}
          nameIntial={getIntials(props.item.archivedBy)}
          personName={getName(props.item.archivedBy)}
          profile={props.item.archivedBy.profile.image}
          isPopover={props.isColumns.isPopover}
          role={
            props.item.archivedBy.profile
              ? props.item.archivedBy.profile.role.name
              : ""
          }
        />
      </td>
    ),
    approval:
      shouldShowApprovalLevel === true ? (
        <td key={v4()}>
          <div
            className={
              props.item.status.name !== "Draft" // Check if status is not "Draft"
                ? formatApprovalStatusData(approvalLevels).filter(
                    (user) => user.status === "APPROVED"
                  ).length === formatApprovalStatusData(approvalLevels).length
                  ? "btn-active w-100"
                  : "btn-pending"
                : "" // No color if status is "Draft"
            }
            onClick={() =>
              onOpenApprovalStatusHandler(
                formatApprovalStatusData(approvalLevels)
              )
            }
          >
            {
              props.item.status.name !== "Draft" // Check if status is not "Draft"
                ? formatApprovalStatusData(approvalLevels).filter(
                    (user) => user.status === "APPROVED"
                  ).length === formatApprovalStatusData(approvalLevels).length
                  ? "Approved"
                  : "Pending"
                : "" // Show "" if status is "Draft"
            }
          </div>
        </td>
      ) : null,
  };

  !props.isArchivedView
    ? (JSXMapping["modifiedBy"] = (
        <td key={v4()}>
          <ProfileWithName
            sKey={props.item.id}
            nameIntial={getIntials(props.item.modifiedBy)}
            personName={getName(props.item.modifiedBy)}
            profile={props.item.modifiedBy.profile.image}
            isPopover={props.isColumns.isPopover}
            role={
              props.item.modifiedBy.profile
                ? props.item.modifiedBy.profile.role.name
                : ""
            }
          />
        </td>
      ))
    : props.isDocumentArchive &&
      props.item.modifiedBy &&
      (JSXMapping["modifiedBy"] = (
        <td key={v4()}>
          <ProfileWithName
            sKey={props.item.id}
            nameIntial={getIntials(props.item.modifiedBy)}
            personName={getName(props.item.modifiedBy)}
            profile={props.item.modifiedBy.profile.image}
            isPopover={props.isColumns.isPopover}
            role={
              props.item.modifiedBy.profile
                ? props.item.modifiedBy.profile.role.name
                : ""
            }
          />
        </td>
      ));

  const getContentRole = (userRoleId) => {
    const document = props.item;
    if (userRoleId === 1 || userRoleId === 2) {
      return [true, { role: "Owner" }];
    } else if (document) {
      const createUserId = document.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = [true, { role: "Owner" }];
      } else {
        const sharedUsers = document.sharedDocument.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" || sharedUser.role === "Collaborator")
        );
        returnedVal = getAccess ? [true, getAccess] : [false];
      }
      return returnedVal;
    }
  };
  return (
    <tr
      key={v4()}
      className={`${props.size ? "folderlist-row" : "list-view-row"} ${
        props.checked ? "folderlist-checked" : ""
      }`}
      onMouseOver={
        props.isColumns.isPinned ? () => props.pinOverHandler() : null
      }
      onMouseOut={props.isColumns.isPinned ? () => props.pinOutHandler() : null}
      onClick={props.click}
    >
      {props.headings.map(
        (column, index) =>
          // index !== props.headings.length - 1 ?
          JSXMapping.hasOwnProperty(column) ? (
            JSXMapping[column]
          ) : props.item.hasOwnProperty(column) ? (
            <td
              key={v4()}
              className={
                props.item[column] && props.item[column].length > 20
                  ? "wrap-text"
                  : ""
              }
            >
              {Array.isArray(props.item[column])
                ? props.item[column].join(", ")
                : props.item[column]}
            </td>
          ) : (
            <td key={v4()}>-</td>
          )
        // : null
      )}
      <td>
        {props.isColumns.isDropDown ? (
          props.isDocumentView ? (
            true ? (
              <Dropdown
                isDisable={!getContentRole(props.userRoleId)[0]}
                contentAccess={getContentRole(props.userRoleId)[1]}
                isArchivedDropdown={props.isColumns.isArchivedDropdown}
                documentId={
                  props.item.folder
                    ? props.item.folder.id
                    : props.item.document.id
                }
                // restoreHandler={() => {
                //   const id = props.item.folder
                //     ? props.item.folder.id
                //     : props.item.document
                //     ? props.item.document.id
                //     : props.item.id;
                //   const title = props.item.folder
                //     ? props.item.folder.title
                //     : props.item.document.title;
                //   props.restoreHandler(
                //     id,
                //     props.item.id,
                //     title,
                //     props.isFolder,
                //     props.item
                //   );
                // }}
                // deleteHandler={() => {
                //   const id = props.item.folder
                //     ? props.item.folder.id
                //     : props.item.document
                //     ? props.item.document.id
                //     : props.item.id;
                //   const title = props.item.folder
                //     ? props.item.folder.title
                //     : props.item.document.title;
                //   props.deleteHandler(
                //     id,
                //     props.item.id,
                //     title,
                //     props.isFolder,
                //     props.item
                //   );
                // }}
                handleEdit={() => {
                  const id = props.item.id || props.item.folderId;
                  props.handleEdit(id);
                }}
                handleShare={() => {
                  props.setShareFolder(props.item);
                }}
                handleArchive={() => {
                  const id = props.item.id || props.item.folderId;
                  props.setArchiveModalVisibility(true, props.item.title, id);
                }}
                isDocumentTemplate={props.isDocumentTemplate}
                // templateEditHandler={(event) =>
                //   props.templateEditHandler(event, props.item.id)
                // }
                // templateDeleteHandler={(event) =>
                //   props.templateDeleteHandler(event, props.item.id)
                // }
                setMoveFileModalVisibility={() =>
                  props.setMoveFileModalVisibility(props.item.id)
                }
                isDocumentView={props.isDocumentView}
              />
            ) : null
          ) : (
            <Dropdown
              isArchivedDropdown={props.isColumns.isArchivedDropdown}
              documentId={
                props.item.folder
                  ? props.item.folder.id
                  : props.item.document.id
              }
              restoreHandler={() => {
                const id = props.item.folder
                  ? props.item.folder.id
                  : props.item.document
                  ? props.item.document.id
                  : props.item.id;
                const title = props.item.folder
                  ? props.item.folder.title
                  : props.item.document.title;
                props.restoreHandler(
                  id,
                  props.item.id,
                  title,
                  props.isFolder,
                  props.item
                );
              }}
              deleteHandler={() => {
                const id = props.item.folder
                  ? props.item.folder.id
                  : props.item.document
                  ? props.item.document.id
                  : props.item.id;
                const title = props.item.folder
                  ? props.item.folder.title
                  : props.item.document.title;
                props.deleteHandler(
                  id,
                  props.item.id,
                  title,
                  props.isFolder,
                  props.item
                );
              }}
              // handleEdit={() => {
              //   const id = props.item.id || props.item.folderId;
              //   props.handleEdit(id);
              // }}
              // handleShare={() => {
              //   props.setShareFolder(props.item);
              // }}
              // handleArchive={() => {
              //   const id = props.item.id || props.item.folderId;
              //   props.setArchiveModalVisibility(true, props.item.title, id);
              // }}
              isDocumentTemplate={props.isDocumentTemplate}
              // templateEditHandler={(event) =>
              //   props.templateEditHandler(event, props.item.id)
              // }
              // templateDeleteHandler={(event) =>
              //   props.templateDeleteHandler(event, props.item.id)
              // }
              // setMoveFileModalVisibility={() =>
              //   props.setMoveFileModalVisibility(props.item.id)
              // }
              isDocumentView={props.isDocumentView}
            />
          )
        ) : null}
      </td>
    </tr>
  );
};

export default DynamicListViewRows;

// Helper components
const StatusButton = (props) => {
  const { item = {}, onClick = () => {}, statusMappings = {} } = props;

  const handleClick = () => {
    onClick(item.id, item.status.name, item.title);
  };

  const getStatusClassName = () => {
    const defaultClassName = "btn-default"; // Default class if status is not found in mappings
    return statusMappings[item.status.name?.toLowerCase()] || defaultClassName;
  };

  return (
    <td key={item.id}>
      <div className={getStatusClassName() + " px-2"} onClick={handleClick}>
        {item.status.name}
      </div>
    </td>
  );
};

// Helper functions
function formatApprovalStatusData(approvalLevels = []) {
  return approvalLevels.reduce((result, approvalLevel) => {
    const approvals = approvalLevel.userApproval.map((approval) => {
      const user = approval.user;

      return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        imageUrl: user.profile.imageUrl,
        userApprovalId: approval.id,
        levelOrder: approvalLevel.sequence,
        name: approvalLevel.name,
        status: approval.status, // I'm including status for reference
      };
    });

    result.push(...approvals);

    return result;
  }, []);
}
